import { usePremiumInfoUrl } from '@src/utils/premiumReturn';
import { Fragment } from 'react';
import { PageContent, Panel, Shell, Link } from '@src/components';
import { ParticipantDecoration } from '@src/components/PersonCard/ParticipantDecoration';
import { Prose } from '@src/components/Prose/Prose';
import { TermsCom } from './TermsCom';
import { isDotCom } from '@src/site';
import agreement from './termsRu.json';
import '@src/pages/PolicyPage/PolicyPage.css';

function LegalText({ text }: { text: string }) {
  const premiumInfoHref = usePremiumInfoUrl();
  return text
    .split(
      /(\*\*[^*]+\*\*|https:\/\/santa-secret\.ru(?:\/policy|\/terms)?|postman@santa-secret\.ru|странице предложения Premium)/g,
    )
    .map((part, index) =>
      part.startsWith('**') && part.endsWith('**') ? (
        <strong key={index}>{part.slice(2, -2)}</strong>
      ) : part === 'странице предложения Premium' ? (
        <Link key={index} href={premiumInfoHref} variant="inline">
          {part}
        </Link>
      ) : part.startsWith('https://') || part === 'postman@santa-secret.ru' ? (
        <Link key={index} href={part.includes('@') ? `mailto:${part}` : part} variant="inline">
          {part}
        </Link>
      ) : (
        <Fragment key={index}>{part}</Fragment>
      ),
    );
}

export function TermsPage() {
  return (
    <Shell>
      <PageContent testId="terms">
        <Panel elevated wide edges={{ pieces: 3 }} testId="terms-panel" className="policy-panel">
          <div className="policy-panel__decorations" aria-hidden="true">
            <ParticipantDecoration variant="crystals" />
            <ParticipantDecoration variant="sparkles" />
            <ParticipantDecoration variant="seasonal" />
          </div>
          {isDotCom() ? (
            <TermsCom />
          ) : (
            <Prose>
              <h1>{agreement.title}</h1>
              <span className="prose__meta">
                <LegalText text={agreement.meta} />
              </span>
              {agreement.sections.map((section, index) => (
                <section key={section.title} aria-labelledby={`terms-section-${index + 1}`}>
                  <h2 id={`terms-section-${index + 1}`}>{section.title}</h2>
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph}>
                      <LegalText text={paragraph} />
                    </p>
                  ))}
                </section>
              ))}
            </Prose>
          )}
        </Panel>
      </PageContent>
    </Shell>
  );
}
